import { lazy } from "react";
import type { SolutionRoute } from "../routes";
import type { SolutionSettings } from "../settings";
import type { NavItem } from "../../nav";
import { Icon } from "../../ui";
import "./website.css";

const MenusPage = lazy(() => import("./menus").then((m) => ({ default: m.MenusPage })));
const OnlineStorePage = lazy(() => import("./overview").then((m) => ({ default: m.OnlineStorePage })));
const PageEditorPage = lazy(() => import("./page").then((m) => ({ default: m.PageEditorPage })));
const PagesPage = lazy(() => import("./pages-list").then((m) => ({ default: m.PagesPage })));
const OnlineStorePreferencesPage = lazy(() => import("./preferences").then((m) => ({ default: m.OnlineStorePreferencesPage })));
const TemplateEditorPage = lazy(() => import("./templates").then((m) => ({ default: m.TemplateEditorPage })));
const TemplatesPage = lazy(() => import("./templates").then((m) => ({ default: m.TemplatesPage })));

/** Website (Online Store in the sidebar): the members' site's look, menus, the business's own pages and the layouts they start from. */

export const routes: SolutionRoute[] = [
  { solution: "website", path: "online-store", element: <OnlineStorePage /> },
  { solution: "website", path: "online-store/preferences", element: <OnlineStorePreferencesPage /> },
  { solution: "website", path: "online-store/menus", element: <MenusPage /> },
  { solution: "website", path: "pages", element: <PagesPage /> },
  { solution: "website", path: "pages/:id", element: <PageEditorPage /> },
  { solution: "website", path: "templates", element: <TemplatesPage /> },
  { solution: "website", path: "templates/:id", element: <TemplateEditorPage /> },
];

export const settings: SolutionSettings[] = [];

export const nav: NavItem = {
  to: "/online-store",
  label: "Online Store",
  icon: Icon.store,
  solution: "website",
  need: "website.view",
  also: ["/pages", "/templates"],
  subs: [
    { to: "/pages", label: "Pages" },
    { to: "/online-store/menus", label: "Menus" },
    { to: "/templates", label: "Page layouts" },
    { to: "/online-store/preferences", label: "Preferences" },
  ],
};
